import type { DynamicFormField, JsonDataItem } from '@myosh/odin-components';
import type { RecordResult } from '../../../@types/records';
import type { SyncDetails } from '../../../redux/middleware/sync-transforms';
import { onlineStatusService } from '../../../services/online-status.service';
import {
  extractHistoryFields,
  extractRecordlinkFieldIds,
  transformHistoryFieldsValue,
  transformRecordlinkFieldsValue,
  transformTimeFieldsValue,
} from './record-component-util';

interface SubmitTransformContext {
  fields: Array<DynamicFormField>;
  fullName?: string;
  isUpdate?: boolean;
  isDbRecord?: boolean;
}

interface SubmitTransformResult {
  record: RecordResult;
  syncDetails: SyncDetails; // details for offline sync
}

export function applySubmitTransforms(
  record: RecordResult,
  data: JsonDataItem,
  context: SubmitTransformContext
): SubmitTransformResult {
  const { fields, isUpdate, isDbRecord } = context;

  // history and recordlink field value updates need special handling
  const historyFields = extractHistoryFields(fields, data);
  const recordLinkFieldIds = extractRecordlinkFieldIds(fields, data);

  let result = record;

  const isOnline = onlineStatusService.getStatus() === true;
  const shouldTransformHistoryFieldValue = isOnline && !isDbRecord;
  if (shouldTransformHistoryFieldValue) {
    result = transformHistoryFieldsValue(result, historyFields);
  }

  result = transformTimeFieldsValue(result, fields);

  if (isUpdate) {
    result = transformRecordlinkFieldsValue(result, recordLinkFieldIds);
  }

  return {
    record: result,
    syncDetails: { historyFields },
  };
}
